import React from 'react';
import { Box, Card, Grid, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import ROUTE_PATH from '../../config/routes.config';

const PageLinks = ({ canEditLicense }) => (
  <Grid container spacing={2.5} mt={0}>
    <Grid item xs={12} sm={4} md={4}>
      <Card sx={{ p: 2 }}>
        <Typography variant="h6">Video Schedule</Typography>

        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
          View video publication dates across supported channels.
        </Typography>

        <Box pt={2} pb={1}>
          <Link
            to={ROUTE_PATH.MANAGE_SCHEDULE}
            component={RouterLink}
            sx={{ display: 'contents' }}
            variant="subtitle1"
          >
            View Schedule
          </Link>
        </Box>
      </Card>
    </Grid>

    <Grid item xs={12} sm={4} md={4}>
      <Card sx={{ p: 2 }}>
        <Typography variant="h6">Manage Licenses</Typography>

        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
          View and manage video license expiration dates. Self-service video
          takedown.
        </Typography>

        <Box pt={2} pb={1}>
          <Link
            to={ROUTE_PATH.LICENSE_MANAGEMENT}
            component={RouterLink}
            sx={{ display: 'contents' }}
            variant="subtitle1"
          >
            {canEditLicense ? 'Manage' : 'View'} License
          </Link>
        </Box>

        {!canEditLicense && (
          <Typography variant="body2" sx={{ opacity: 0.85 }}>
            * You don&apos;t have the permission to edit licenses
          </Typography>
        )}
      </Card>
    </Grid>

    <Grid item xs={12} sm={4} md={4}>
      <Card sx={{ p: 2 }}>
        <Typography variant="h6">Account information</Typography>

        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
          View basic details and security information.
        </Typography>

        <Box pt={2} pb={1}>
          <Link
            to={ROUTE_PATH.USER_PROFILE}
            component={RouterLink}
            sx={{ display: 'contents' }}
            variant="subtitle1"
          >
            View Profile
          </Link>
        </Box>
      </Card>
    </Grid>
  </Grid>
);

PageLinks.propTypes = {
  canEditLicense: PropTypes.bool.isRequired,
};

export default PageLinks;
